import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";

import { ANALYTICS } from "../constants";
import { CellComponentProps } from "../types";
import { showUnassignConfirmation } from "../UnassignConfirmation";

type UserRolesListItemActionsDropdownCellProps = CellComponentProps & {
  isLastRole: boolean;
};

const UserRolesListItemActionsDropdownCell = ({
  roleBinding,
  isLastRole,
}: UserRolesListItemActionsDropdownCellProps) => {
  const roleUrl = `/settings/role/${roleBinding.role.id}`;

  return (
    <DropdownMenuEllipsis tooltip="Role actions">
      {!roleBinding.role.isSystem && (
        <DropdownMenuItem
          {...ANALYTICS}
          analyticsTitle="Preview permissions clicked"
          href={roleUrl}
        >
          Preview permissions
        </DropdownMenuItem>
      )}
      <DropdownMenuItem
        {...ANALYTICS}
        danger
        analyticsTitle="Unassign clicked"
        onAction={() =>
          showUnassignConfirmation({ id: roleBinding.id, name: roleBinding.role.name, isLastRole })
        }
      >
        Unassign
      </DropdownMenuItem>
    </DropdownMenuEllipsis>
  );
};

export default UserRolesListItemActionsDropdownCell;
